import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { Shield } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "super_admin") {
        setError("This login is for super admins only.");
        return;
      }
      toast.success("Welcome, admin.");
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-navy flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-10">
        <div className="flex items-center justify-between mb-6">
          <Logo size={44} />
          <div className="flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] font-bold text-brand-orange">
            <Shield className="w-3.5 h-3.5" /> Admin
          </div>
        </div>
        <h2 className="font-heading font-bold text-3xl">Super admin access</h2>
        <p className="text-foreground/60 mt-2 text-sm">Restricted area. Platform owners only.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="admin-login-email" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="admin-login-password" />
          </div>
          {error && <div className="text-sm text-destructive" data-testid="admin-login-error">{error}</div>}
          <Button type="submit" disabled={loading} className="w-full bg-brand-navy hover:bg-[#1A2B42] text-white h-11 rounded-full font-semibold" data-testid="admin-login-submit">
            {loading ? "Authenticating…" : "Enter admin panel"}
          </Button>
        </form>
      </div>
    </div>
  );
}
